import axios from 'axios';
export default {
  async getCustomFields(clientId) {
    const {
      data
    } = await axios.get(`/clients/${clientId}/customfields`);
    return data;
  },
  async updateCustomFields(clientId, customFields) {
    const {
      data
    } = await axios.put(`/clients/${clientId}/customfields`, {
      customFields
    });
    return data;
  }
};